import VueSelect from './components/Select.vue'
import mixins from './mixins/index.js'

export default VueSelect
export { VueSelect, mixins }
